import { viewport } from './helper/viewport';

import Nav from './nav/nav';

import ModuleFactory from './modules/index';
import Hero from './bricks/hero';
import ProductSliderFactory from './bricks/products';
import ContactFormFactory from './bricks/contact-form';

import Context from './modules/context';
import AccordionFactory from './modules/accordion';
import Forms from './modules/forms';
import SelectFactory from './modules/select';
import ModalFactory from './modules/modal';
import ModalLang from './modules/modal-lang';
import LxpNewsFactory from './modules/lxpnews';

import Login from './modules/login';
import Register from './modules/register';

import NewsFactory from './bricks/news';
import SliderFactory from './bricks/slider';

import LxpNewsTeaserItemFactory from './components/teaserItem';

document.addEventListener('DOMContentLoaded', () => {
  new Nav();

  const navItems = document.querySelectorAll('.sg-header .sg-header__nav-item');
  const path = window.location.pathname;
  const navItemActive = Array.from(navItems).find(
    (item) => item.getAttribute('href') === path,
  );

  if (navItemActive) {
    navItemActive.classList.add('active');
  }

  new LxpNewsFactory();
  new ModuleFactory();
  new Hero();
  new ProductSliderFactory();
  new ContactFormFactory();

  new Context();
  new Forms();
  new AccordionFactory();
  new SelectFactory();
  new ModalFactory();
  new ModalLang();

  new Login();
  new Register();

  new SliderFactory();

  new LxpNewsTeaserItemFactory();
  new NewsFactory();

  const vp = viewport();
  vp.init();
});
